var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticClass:"blog-gallery",attrs:{"row":"","wrap":""}},_vm._l((_vm.$slots.default),function(item,index){return _c('v-flex',{key:index,attrs:{"xs12":"","sm6":"","md4":"","lg3":""}},[_vm._t(item)],2)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }